import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const styles = theme => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing.unit / 2,
    minHeight: 100,
    paddingLeft: 200
  },
  chip: {
    margin: theme.spacing.unit / 2
  }
});

class ChipsComp extends PureComponent {
  render() {
    const { classes, chipData } = this.props;
    return (
      <div classes={{ root: classes.root }}>
        {chipData.map(data => {
          return (
            <Chip
              key={data.key}
              label={data.label}
              onDelete={() => {}}
              className={classes.chip}
            />
          );
        })}
      </div>
    );
  }
}

ChipsComp.propTypes = {
  classes: PropTypes.shape({}),
  chipData: PropTypes.arrayOf(PropTypes.shape({}))
};

ChipsComp.defaultProps = {
  classes: {},
  chipData: []
};
export const Chips = withStyles(styles)(ChipsComp);
